import { Injectable } from '@angular/core';
import { Models } from '@ibexfusion/models';

import { RestProvider, RestService } from '../rest/rest.service';
import { RestfulService } from '../rest/restful';

@Injectable()
export class AdditionalProfileDataService extends RestfulService<Models.AdditionalProfileData> {

  constructor(private restService: RestService) {
    super(Models.AdditionalProfileData);
    super.init();
  }

  public createProvider(): RestProvider {
    return this.restService.createProvider('additional-profile-datas');
  }
}

